export const messages = {
    "shared-link.footer.link.install": "{brandName} ürününü ücretsiz deneyin",
    "shared-link.footer.link.mobile": "Mobil cihazlar için {brandName}",
    "shared-link.footer.link.android": "Android",
    "shared-link.footer.link.ios": "iOS",
    "shared-link.password-dialog-box.title": "Korunan veriler",
    "shared-link.password-dialog-box.message": "Paylaşılan verilere erişmek için lütfen parola belirtin",
    "shared-link.password-dialog-box.hint.password": "Şifre",
    "shared-link.password-dialog-box.message.invalid-password": "Parola hatalı",
    "shared-link.form.button.open": "Açma",
    "shared-link.page-not-found.title": "Sayfa bulunamadı",
    "shared-link.page-not-found.message.main": "Aradığınız sayfa bulunamadı.",
    "shared-link.page-not-found.message.description": "Bağlantının süresi geçmiş ya da adresi hatalı yazmış olabilirsiniz.",
    "shared-link.page-not-found.message.error": "Hata kodu: 404",
    "shared-link.restore-file.label.size": "Boyut",
    "shared-link.restore-file.button.restore": "İndir",
    "shared-link.links-table.column.name": "Ad",
    "shared-link.links-table.column.size": "Boyut",
    "shared-link.links-table.action.restore": "İndir",
    "shared-link.links-table.action.restore-all": "Tümünü indir",
    "shared-link.side-bar.selected.title:plural": "{count} öğe seçildi | {count} öğe seçildi | {count} öğe seçildi",
    "shared-link.links-table.label.size": "Boyut",
    "shared-link.links-table.message.empty-folder": "Bu klasör boş"
};
